import { FC, ReactNode } from "react";

export const TimerTextWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="relative">
      {/* Invisible placeholder to avoid layout shift */}
      <span className="invisible block">00:00:00</span>
      <span className="absolute top-0 left-0">{children}</span>
    </div>
  );
};
